var render, staticRenderFns
import script from "./BaseTransitionExpand.vue?vue&type=script&lang=js&"
export * from "./BaseTransitionExpand.vue?vue&type=script&lang=js&"
import style0 from "./BaseTransitionExpand.vue?vue&type=style&index=0&id=6c926ae2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c926ae2",
  null
  
)

export default component.exports